export * from './sidebar.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/sidebar/index.ts